module.exports = __webpack_public_path__ + "img/pegawai_presensi_hari_ini.8568529c.png";